import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[appNoF5Directive]',
    standalone: false
})
export class NoF5DirectiveDirective {
  blockedKeyCombinations: Set<string> = new Set(['F5', 'Control+r', 'Control+Shift+R']);
  @Output() f5Pressed: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() { }
  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const keyCombination = this.getKeyCombination(event);
    if (this.blockedKeyCombinations.has(keyCombination)) {
      event.preventDefault();
      this.f5Pressed.emit(true);
      console.log('Page refresh is disabled for the pressed key combination:', keyCombination);
    }
  }


  private getKeyCombination(event: KeyboardEvent): string {
    const key = event.key;
    const ctrlKey = event.ctrlKey ? 'Control+' : '';
    const shiftKey = event.shiftKey ? 'Shift+' : '';

    return `${ctrlKey}${shiftKey}${key}`;
  }
}
